import { render, staticRenderFns } from "./modalAttachMail.vue?vue&type=template&id=a6e87220&scoped=true"
import script from "./modalAttachMail.vue?vue&type=script&lang=js"
export * from "./modalAttachMail.vue?vue&type=script&lang=js"
import style0 from "./modalAttachMail.vue?vue&type=style&index=0&id=a6e87220&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e87220",
  null
  
)

export default component.exports